import "../css/navbar.css";
import { Link } from "react-router-dom";
import big_logo_long from "../img/big_logo_long.png";

const Navbar = () => {
  return (
    <nav>
      <div id="logo">
        <Link to="/">
          <img src={big_logo_long} alt="big_logo_long.png" />
        </Link>
      </div>
      <div id="nav_menu">
        <div id="nav_menu_text">
          <Link class="nav_link" to="/about">
            About
          </Link>
          <Link class="nav_link" to="/documentation">
            Documentation
          </Link>
          <a class="nav_link" href="https://github.com/tomcreigh/CheatSheet">
            GitHub
          </a>
        </div>
        <div id="nav_menu_button">
          <a
            class="download_btn"
            href="https://chrome.google.com/webstore/detail/cheatsheet/mgfdddgcpjkoondkodggdigadgjjklgo/related?hl=en&authuser=0"
          >
            Download
          </a>
        </div>
      </div>
      <div id="dropdown_nav" role="navigation">
        <div id="menuToggle">
          <input type="checkbox" />

          <span></span>
          <span></span>
          <span></span>

          <div id="nav_menu_text">
            <Link class="nav_link" to="/">
              Home
            </Link>
            <Link class="nav_link" to="/about">
              About
            </Link>
            <Link class="nav_link" to="/documentation">
              Documentation
            </Link>
            <a class="nav_link" href="https://github.com/tomcreigh/CheatSheet">
              GitHub
            </a>
            <a
              class="download_btn"
              href="https://chrome.google.com/webstore/detail/cheatsheet/mgfdddgcpjkoondkodggdigadgjjklgo/related?hl=en&authuser=0"
            >
              Download
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
